/*
 * @Author: linbin@leedarson.com
 * @Date: 2022-11-30 17:24:29
 * Copyright © Leedarson. All rights reserved.
 */

import { ILogRecord } from './types';

const KEY = 'log_data';
const MAX = 50;

const setLocalStorageRecord = (data: ILogRecord | ILogRecord[]) => {
  let records = getLocalStorageRecord();
  if (Array.isArray(data)) {
    // 上传失败，曳光弹保留原来的数据
    const mLen = records.length;
    const dLen = data.length;
    if (mLen + dLen > MAX) {
      if (mLen > MAX) {
        records = records.slice(-MAX); // slice 不会改变原来数组, slice 负数表示从后往前
      } else {
        records.unshift(...data.slice(-(MAX - mLen))); // unshift 会改变原来数组, slice 负数表示从后往前
      }
    } else {
      records.unshift(...data); // unshift 会改变原来数组
    }
  } else {
    // 正常上报逻辑
    if (records.length > MAX) {
      records.shift(); // shift 会改变原来数组
    }
    records.push(data); // push 会改变原来数组
  }
  window.localStorage.setItem(KEY, JSON.stringify(records));
};

const getLocalStorageRecord = () => {
  const localData = window.localStorage.getItem(KEY);
  let records = [];
  if (localData) {
    records = JSON.parse(localData);
  }
  return records;
};

const removeLocalStorageRecord = () => {
  window.localStorage.removeItem(KEY);
};

export { setLocalStorageRecord, getLocalStorageRecord, removeLocalStorageRecord };
